import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Input, Button } from "antd";
import { API_BASE_URL, API_ENDPOINTS } from "../../config/api";
import Toast from "../../utils/toast";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    const emailVal = values.email?.trim() || "";
    if (!emailVal) {
      Toast.error("Email is required");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(emailVal)) {
      Toast.error("Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      const endpoint =
        API_ENDPOINTS.FORGOT_PASSWORD || API_ENDPOINTS.forgotPassword;
      const url = `${API_BASE_URL}${endpoint}`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email: emailVal }),
      });
      const data = await response.json();

      if (response.ok) {
        const successMessage =
          data.message || "Password reset link sent to your email!";
        Toast.success(successMessage);
        setTimeout(() => navigate("/login"), 2000);
      } else {
        const errorMessage =
          data.message || data.error || "Failed to send reset link";
        Toast.error(errorMessage);
      }
    } catch (error) {
      if (error.message?.includes("Failed to fetch")) {
        Toast.error(
          "Cannot connect to server. Please check if backend is running.",
        );
      } else {
        Toast.error("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <Card className="forgot-password-card" title={null}>
        <div className="header">
          <h2>Forgot Password</h2>
          <p>Enter your email to reset your password</p>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: "Email is required" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input
              placeholder="you@example.com"
              size="large"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              Send Reset Link
            </Button>
          </Form.Item>
        </Form>

        <div className="back-link">
            <Button
              type="link"
              onClick={() => navigate("/login")}
              disabled={loading}
              style={{ color: "#066744" }}
            >
            ← Back to Login
          </Button>
        </div>

        <div className="footer-note">
          <p>
            We'll send you a link to reset your password. Check your inbox and
            spam folder.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;
